import { AbstractStorageService } from './abstract-storage.service';

export class LocalStorageService extends AbstractStorageService {
    constructor() {
        super(window.localStorage);
    }
}